import React, { useRef, useState, useEffect } from 'react';

import '../App.css';

import { MapContainer, TileLayer, WMSTileLayer, LayersControl, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';

import Axios from 'axios';
import FileDownload from 'js-file-download';

import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';

import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';

import { makeStyles } from '@mui/styles';
import { styled, createTheme, alpha } from '@mui/material/styles';

import Highcharts, { theme } from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import {
    Box,
    Stack,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    CircularProgress,
    Skeleton,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Fab,
    Tooltip,
    FormControlLabel,
    Switch,
    colors,
    Divider,
    // getIconButtonUtilityClass
} from "@mui/material";

import HomeIcon from '@mui/icons-material/Home';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import LayersIcon from '@mui/icons-material/Layers';
import MapIcon from '@mui/icons-material/Map';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import gistdaPic from '../imgs/gistda_logo.png';
import kuPic from '../imgs/ku.png';
import mhesiPic from '../imgs/mhesi.png';
import nrctPic from '../imgs/nrct.png';
import pcdPic from '../imgs/pcd.png';
import ccdcPic from '../imgs/ccdc.png';
import andPic from '../imgs/android.png';
import aaplPic from '../imgs/aapl.png';
import PMUBPic from '../imgs/PMUB-01.png';
import pinPic from '../imgs/pin.svg';
// import  from '../imgs/.svg';
import basebg from '../imgs/bg.jpg'
import Wt1 from '../imgs/WeatherIcon1.png'
import Wt2 from '../imgs/WeatherIcon2.png'
import Wt3 from '../imgs/WeatherIcon3.png'


import InfoIcon from '@mui/icons-material/Info';

import color1Pic from '../imgs/color1.png';
import color2Pic from '../imgs/color2.png';
import color3Pic from '../imgs/color3.png';
import color4Pic from '../imgs/color4.png';
import color5Pic from '../imgs/color5.png';
import colorbarPic from '../imgs/level_bar.png';

import phonePic from '../imgs/phone.png';
import logoIcon from '../imgs/logo.png';
import aapl from '../imgs/aapls.png';
import googl from '../imgs/googl.png';
import x from '../imgs/x.png';

import { Await } from 'react-router-dom';

import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import TablePagination from '@mui/material/TablePagination';

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
// import Button from "@mui/material/Button";

import { Autocomplete, TextField } from '@mui/material/';

let sphere = null;
let map = null;

const Home = () => {


    //===============================================================================

    // const variable array to save the users location
    const [userLocation, setUserLocation] = useState(null);

    const GEO_TIMEOUT = 5000;
    const timeoutId = setTimeout(() => {

        // console.log('trying to retrieve geo-location, but timed out');
    }, GEO_TIMEOUT);

    // define the function that finds the users geolocation
    const getUserLocation = () => {
        // if geolocation is supported by the users browser
        if (navigator.geolocation) {
            // get the current users location
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    clearTimeout(timeoutId);
                    // save the geolocation coordinates in two variables
                    const { latitude, longitude } = position.coords;
                    // update the value of userlocation variable
                    setUserLocation({ latitude, longitude });
                    getDataLocation(position.coords.latitude, position.coords.longitude);
                    // console.log("#1")
                },
                () => {
                    //   clearTimeout(timeoutId);
                    getDataLocation(13.8810, 100.5640);

                    // console.error('Unable to retrieve location2')
                },
                { timeout: GEO_TIMEOUT },
                // if there was an error getting the users location
                (error) => {
                    console.error('Error getting user location:', error);
                    getDataLocation(13.8810, 100.5640);
                    // console.log("#2")
                }
            );
        }
        // if geolocation is not supported by the users browser
        else {
            console.error('Geolocation is not supported by this browser.');
            getDataLocation(13.8810, 100.5640);
            // console.log("#3")
        }
    };


    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: window.screen.width > 700 ? 700 : 350,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        borderRadius: '25px',
    };

    const StyledTableRow = styled(TableRow)(({ theme }) => ({

        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.default,
        },
        // '&:nth-of-type(even)': {
        //     backgroundColor: theme.palette.default,
        // },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    // const [dateTime, setDateTime] = useState('');

    const [urlHotspot, setUrlHotspot] = useState('https://gistdaportal.gistda.or.th/data/services/pm_check/hotspot_pmcheck/MapServer/WMSServer');
    const [urlPM25, setUrlPM25] = useState('https://service-proxy-765rkyfg3q-as.a.run.app/api_geoserver/geoserver/pm25_hourly_raster/wms');
    const [urlPM2524, setUrlPM2524] = useState('https://service-proxy-765rkyfg3q-as.a.run.app/api_geoserver/geoserver/pm25_hourly_raster_24hr/wms');
    const [urlProvince, setUrlProvince] = useState('https://gistdaportal.gistda.or.th/data2/services/L05_Province_GISTDA_50k_nonlabel/MapServer/WMSServer');
    const [allData, setAllData] = useState([]);
    const [allTime, setAllTime] = useState([]);

    const [allData0, setAllData0] = useState([]);
    const [allTime0, setAllTime0] = useState([]);

    const [basemap, setBasemap] = useState([]);
    const [sBasemap, setsBasemap] = useState([]);
    const [cData, setcData] = useState([null, null]);
    const [cData0, setcData0] = useState([null, null]);

    const [open, setOpen] = useState(false);
    const [openAds, setOpenAds] = useState(true);
    const [openX, setOpenX] = useState(false);
    const [openI, setOpenI] = useState(false);
    const [open1, setOpen1] = useState(false);
    const [openA, setOpenA] = useState(false);
    const [openT, setOpenT] = useState(false);
    const handleClose = () => setOpen(false);
    const handleCloseAds = () => setOpenAds(false);
    const handleCloseX = () => setOpenX(false);
    const handleCloseI = () => setOpenI(false);
    const handleClose1 = () => setOpen1(false);
    const handleCloseA = () => setOpenA(false);
    const handleCloseT = () => setOpenT(false);

    const [openAuto, setOpenAuto] = useState(false);


    const [modalName, setModalName] = useState([]);
    const [modalNameA, setModalNameA] = useState([]);
    const [modalNameT, setModalNameT] = useState([]);

    const [lastDt, setLastDt] = useState([]);
    const [predDt, setPredDt] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedDataLocation, setFetchedDataLocation] = useState([]);
    const [fetchedDataWeatherLocation, setFetchedDataWeatherLocation] = useState([]);
    const [isLoadingLocation, setIsLoadingLocation] = useState(false);
    const [fetchedDataAmphoe, setFetchedDataAmphoe] = useState([]);
    const [isLoadingAmphoe, setIsLoadingAmphoe] = useState(false);
    const [fetchedDataTambon, setFetchedDataTambon] = useState([]);
    const [isLoadingTambon, setIsLoadingTambon] = useState(false);
    const [fetchedData24, setFetchedData24] = useState([]);
    const [isLoading24, setIsLoading24] = useState(false);
    const [fetchedData24Amphoe, setFetchedData24Amphoe] = useState([]);
    const [isLoadingMap, setIsLoadingMap] = useState(false);
    const [isLoadingName, setIsLoadingName] = useState(false);


    const [areaList, setAreaList] = useState([{
        name_th: "กรุงเทพมหานคร",
        name_en: "Bangkok",
        id: 10,
        name: "กรุงเทพมหานคร Bangkok",
    }]);
    const [bbox, setBbox] = useState([[20.464903221106795, 105.6370220133553], [5.61275656816116, 97.34371998448972]]);

    const [map, setMap] = useState(null);

    const [openHotspot, setOpenHotspot] = useState(true);
    const [openProvince, setOpenProvince] = useState(true);

    const [expanded, setExpanded] = useState([]);

    const [selectedArea, setSelectedArea] = useState([]);


    const [fullPath, setFullPath] = useState('https://pm25.gistda.or.th');


    // =======================================================================


    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    const [headCells, setHeadCells] = useState([
        {
            id: 'p_name',
            numeric: false,
            disablePadding: false,
            label: 'จังหวัด',
        },
        {
            id: 'p_PM25',
            numeric: true,
            disablePadding: false,
            label: 'ชั่วโมงล่าสุด (µg/m³)',
        },
        {
            id: 'p1',
            numeric: true,
            disablePadding: false,
            label: `คาดการณ์รายชั่วโมงถัดไป`,
        },
        {
            id: 'p_24PM25',
            numeric: true,
            disablePadding: false,
            label: 'เฉลี่ย 24 ชั่วโมง (µg/m³)',
        },
        {
            id: 'detail',
            numeric: true,
            disablePadding: false,
            label: 'รายอำเภอ',
        },
        {
            id: 'chart',
            numeric: true,
            disablePadding: false,
            label: 'ข้อมูลกราฟ',
        },
    ]);

    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } =
            props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {/* <TableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{
                                'aria-label': 'select all desserts',
                            }}
                        />
                    </TableCell> */}
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.numeric ? 'center' : 'left'}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >

                                {headCell.id === 'p1' ?
                                    <div>คาดการณ์<br />{isLoading ? '' : `ณ ${predDt[0]}`}<br />{isLoading ? '' : `${fetchedData.length > 0 && fetchedData[0].p1 * 0 === 0 ? `${predDt[1]} |` : ''} ${fetchedData.length > 0 && fetchedData[0].p2 * 0 === 0 ? `${predDt[2]} |` : ''} ${fetchedData.length > 0 && fetchedData[0].p3 * 0 === 0 ? `${predDt[3]}` : ''} `}</div>
                                    : headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    EnhancedTableHead.propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    // function EnhancedTableToolbar(props) {
    //     const { numSelected } = props;
    //     return (
    //         <Toolbar
    //             sx={[
    //                 {
    //                     pl: { sm: 2 },
    //                     pr: { xs: 1, sm: 1 },
    //                 },
    //                 numSelected > 0 && {
    //                     bgcolor: (theme) =>
    //                         alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
    //                 },
    //             ]}
    //         >
    //             {numSelected > 0 ? (
    //                 <Typography
    //                     sx={{ flex: '1 1 100%' }}
    //                     color="inherit"
    //                     variant="subtitle1"
    //                     component="div"
    //                 >
    //                     {numSelected} selected
    //                 </Typography>
    //             ) : (
    //                 <Typography
    //                     sx={{ flex: '1 1 100%' }}
    //                     variant="h6"
    //                     id="tableTitle"
    //                     component="div"
    //                 >
    //                     Nutrition
    //                 </Typography>
    //             )}
    //             {numSelected > 0 ? (
    //                 <Tooltip title="Delete">
    //                     <IconButton>
    //                         <DeleteIcon />
    //                     </IconButton>
    //                 </Tooltip>
    //             ) : (
    //                 <Tooltip title="Filter list">
    //                     <IconButton>
    //                         <FilterListIcon />
    //                     </IconButton>
    //                 </Tooltip>
    //             )}
    //         </Toolbar>
    //     );
    // }

    // EnhancedTableToolbar.propTypes = {
    //     numSelected: PropTypes.number.isRequired,
    // };

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('p_name');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(77);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = fetchedData.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - fetchedData.length) : 0;

    const visibleRows = React.useMemo(
        () =>
            [...fetchedData]
                .sort(getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [order, orderBy, page, rowsPerPage],
    );

    // const [visibleRows, setVisibleRows] = React.useState([]);

    // const handleChangeVisible = () => {
    //     setVisibleRows(
    //         () =>
    //             [...fetchedData]
    //                 .sort(getComparator(order, orderBy))
    //                 .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    //         [order, orderBy, page, rowsPerPage],
    //     );
    // }

    // function setPVID(i) {
    //     now_pv_id = i;
    // }

    const handleChange = () => {

        setsBasemap(sBasemap === 1 ? 0 : 1);
        // console.log(basemap);
        setBasemap(sBasemap === 1 ? 0 : 1);

        // toggleBasemap(basemap);
    };

    const handleOpen = (id, level, name) => {
        setIsLoading24(true);
        getData24(id, level);

        var sid = id.toString();
        var bkk = sid.slice(0, 2) === '10'

        var lv = "";
        if (level === "Province") {
            bkk ? lv = "" : lv = "จังหวัด";
        } else if (level === "Amphoe") {
            bkk ? lv = "เขต" : lv = "อำเภอ";
        } else if (level === "Tambon") {
            bkk ? lv = "แขวง" : lv = "ตำบล";
        }
        // setModalName(lv + name);
        setModalName(lv + name);
    };

    const handleOpen1 = () => {
        setOpen1(true);
    }
    const handleOpenX = () => {
        setOpenX(true);
    }
    const handleOpenI = () => {
        setOpenI(true);
    }
    const handleOpenA = (id, name) => {
        setOpenA(true);
        getDataAmphoe(id);

        setModalNameA(id.toString().slice(0, 2) === "10" ? "ข้อมูลรายเขตของ" + name : "ข้อมูลรายอำเภอของจังหวัด" + name);
    }
    const handleOpenT = (id, name) => {
        setOpenT(true);
        getDataTambon(id);

        setModalNameT(id.toString().slice(0, 2) === "10" ? "ข้อมูลรายแขวงของเขต" + name : "ข้อมูลรายตำบลของอำเภอ" + name);
    }

    const getUrl = async () => {
        setIsLoadingMap(true);
        const response = await fetch(
            fullPath + "/rest/getUrl"
        );
        const result = await response.json();

        setUrlPM25(await result.data.find(obj => obj.wms === "pm25").url);
        setUrlPM2524(await result.data.find(obj => obj.wms === "pm25_24hrs").url);
        setUrlProvince(await result.data.find(obj => obj.wms === "province").url);
        setUrlHotspot(await result.data.find(obj => obj.wms === "hotspot").url);
        setIsLoadingMap(false);

    };

    const getDataLocation = async (lat, lng) => {
        setIsLoadingLocation(true);

        const response1 = await fetch(
            fullPath + `/rest/getPm25byLocation?lat=${lat}&lng=${lng}`
        );
        const result1 = await response1.json();
        setFetchedDataLocation(
            result1.data
        );

        const response2 = await fetch(
            fullPath + `/rest/getWeatherbyLocation?lat=${lat}&lng=${lng}`
        );
        const result2 = await response2.json();
        setFetchedDataWeatherLocation(
            result2.data[0]
        );

        const response3 = await fetch(
            fullPath + `/rest/pred/getPm25byLocation?lat=${lat}&lng=${lng}`
        );
        const result3 = await response3.json();

        const r1 = result1.data.graphHistory24hrs;

        var alldata = [];
        var alltime = [];

        let n, m = 0;

        for (var i = 0; i < r1.length; i++) {
            // { y: parseInt(Data[i]), color: '#FF0000' }
            let thisValue = parseFloat(r1[i][0].toFixed(1));
            let thisColor = '#FFF';

            if (thisValue <= 15.0) {
                thisColor = "#4AC3FF96";
            } else if (thisValue <= 25.0) {
                thisColor = "#90DB4196";
            } else if (thisValue <= 37.5) {
                thisColor = "#FFD34796";
            } else if (thisValue <= 75.0) {
                thisColor = "#FF984A96";
            } else {
                thisColor = "#C03A3096";
            }
            alldata.push({ y: thisValue, color: thisColor });

            alltime.push(r1[i][1].split("T")[1].replace(":00.000Z", " น."));
            n++;
        }

        const r2 = result3.data.graphPredictByHrs;

        for (var i = 0; i < r2.length; i++) {
            // { y: parseInt(Data[i]), color: '#FF0000' }
            let thisValue = parseFloat(r2[i][0].toFixed(1));
            let thisColor = '#FFF';

            if (thisValue <= 15.0) {
                thisColor = "#4AC3FF96";
            } else if (thisValue <= 25.0) {
                thisColor = "#90DB4196";
            } else if (thisValue <= 37.5) {
                thisColor = "#FFD34796";
            } else if (thisValue <= 75.0) {
                thisColor = "#FF984A96";
            } else {
                thisColor = "#C03A3096";
            }
            alldata.push({ y: thisValue, color: thisColor, borderColor: '#FF0' });

            alltime.push(`(คาดการณ์) ${r2[i][1].split("T")[1].replace(":00.000Z", " น.")}`);
            m++;
        }

        setAllData0(alldata);
        setAllTime0(alltime);

        setcData0([n, m]);

        setIsLoadingLocation(false);
    };

    const getDataArea = async (id) => {
        setIsLoadingLocation(true);
        setFetchedDataLocation(null);

        if (typeof id == "undefined") {
            return;
        }

        let lv = id > 99999 ?
            ['Tambon', 'tb_idn'] : id > 999 ?
                ['Amphoe', 'ap_idn'] : id > 9 ?
                    ['Province', 'pv_idn'] : false;

        const response1 = await fetch(
            fullPath + `/rest/getPM25by${lv[0]}24hrs?${lv[1]}=${id}`
        );
        let result1 = await response1.json();

        const average = (array) => array.reduce((a, b) => parseFloat(a) + parseFloat(b)) / array.length;
        result1.pm25Avg24hrs = average(result1.graphHistory24hrs);

        result1.pm25 = result1.graphHistory24hrs.at(-1)[0];

        console.log(result1.pm25Avg24hrs) 
        console.log(result1.pm25) 
        // result1.loc.loctext = selectedArea.name_th;

        // console.log(result1)

        setFetchedDataLocation(
            result1
        );

        const response2 = await fetch(
            fullPath + `/rest/getWeatherbyArea?id=${id}`
        );
        const result2 = await response2.json();
        setFetchedDataWeatherLocation(
            result2.data[0]
        );

        const response3 = await fetch(
            fullPath + `/rest/pred/getPM25by${lv[0]}?${lv[1]}=${id}`
        );
        const result3 = await response3.json();

        const r1 = result1.graphHistory24hrs;

        var alldata = [];
        var alltime = [];

        let n, m = 0;

        for (var i = 0; i < r1.length; i++) {
            // { y: parseInt(Data[i]), color: '#FF0000' }
            let thisValue = parseFloat(r1[i][0].toFixed(1));
            let thisColor = '#FFF';

            if (thisValue <= 15.0) {
                thisColor = "#4AC3FF96";
            } else if (thisValue <= 25.0) {
                thisColor = "#90DB4196";
            } else if (thisValue <= 37.5) {
                thisColor = "#FFD34796";
            } else if (thisValue <= 75.0) {
                thisColor = "#FF984A96";
            } else {
                thisColor = "#C03A3096";
            }
            alldata.push({ y: thisValue, color: thisColor });

            alltime.push(r1[i][1].split("T")[1].replace(":00.000Z", " น."));
            n++;
        }

        const r2 = result3.graphPredictByHrs;

        for (var i = 0; i < r2.length; i++) {
            // { y: parseInt(Data[i]), color: '#FF0000' }
            let thisValue = parseFloat(r2[i][0].toFixed(1));
            let thisColor = '#FFF';

            if (thisValue <= 15.0) {
                thisColor = "#4AC3FF96";
            } else if (thisValue <= 25.0) {
                thisColor = "#90DB4196";
            } else if (thisValue <= 37.5) {
                thisColor = "#FFD34796";
            } else if (thisValue <= 75.0) {
                thisColor = "#FF984A96";
            } else {
                thisColor = "#C03A3096";
            }
            alldata.push({ y: thisValue, color: thisColor, borderColor: '#FF0' });

            alltime.push(`(คาดการณ์) ${r2[i][1].split("T")[1].replace(":00.000Z", " น.")}`);
            m++;
        }

        setAllData0(alldata);
        setAllTime0(alltime);

        setcData0([n, m]);

        setIsLoadingLocation(false);
    };

    const getName = async (name) => {
        setIsLoadingName(true);

        const response = await fetch(
            fullPath + "/rest/getname?name=" + name
        );
        const result = await response.json();

        setAreaList(
            result.data.map((data) => ({
                name_th: data.name_th,
                name_en: data.name_en,
                id: data.id,
                name: data.name_th + " " + data.name_en,
            }))
        );
        setIsLoadingName(false);

    };

    const getBbox = async (name) => {
        if (typeof name == "undefined") {
            getUserLocation();
            // return;
        }

        const response = await fetch(
            fullPath + "/rest/getbbox?id=" + name
        );
        const result = await response.json();
        let r = result.data[0];

        // console.log([
        //     [r.minlng, r.minlat], // Southwest
        //     [r.maxlng, r.maxlat] // Northeast
        // ])

        setBbox([
            [r.minlng, r.minlat], // Southwest
            [r.maxlng, r.maxlat] // Northeast
        ]);

        map.flyToBounds([
            [r.minlng, r.minlat], // Southwest
            [r.maxlng, r.maxlat] // Northeast
        ])

    };

    const getData = async () => {
        const response = await fetch(
            fullPath + "/rest/getPm25byProvincePred3"
            // "http://127.0.0.1:5000/rest/getPm25byProvincePred3"
        );
        const result = await response.json();

        const timeString = result.data[0].dt_predict;
        const dateTime = new Date(timeString);
        dateTime.setHours(dateTime.getHours() - 7);
        const newTimeString0 = dateTime.toTimeString().split(":")[0] + ":00"; // "00:00"
        dateTime.setHours(dateTime.getHours() + 1);
        const newTimeString1 = dateTime.toTimeString().split(":")[0] + ":00"; // "01:00"
        dateTime.setHours(dateTime.getHours() + 1);
        const newTimeString2 = dateTime.toTimeString().split(":")[0] + ":00"; // "02:00"
        dateTime.setHours(dateTime.getHours() + 1);
        const newTimeString3 = dateTime.toTimeString().split(":")[0] + ":00"; // "03:00"

        setLastDt(result.datetimeThai);
        setPredDt([newTimeString0, newTimeString1, newTimeString2, newTimeString3]);

        setFetchedData(
            result.data.map((province) => ({
                p_name: province.pv_tn,
                p_PM25: parseFloat(parseFloat(province.pm25).toFixed(1)),
                p_24PM25: parseFloat(parseFloat(province.pm25Avg24hr).toFixed(1)),
                p_id: province.pv_idn,
                p1: parseFloat(parseFloat(province.pred1).toFixed(1)),
                p2: parseFloat(parseFloat(province.pred2).toFixed(1)),
                p3: parseFloat(parseFloat(province.pred3).toFixed(1)),
                // p_datetime: province.dt.split("T")[0].concat(" ", province.dt.split("T")[1].replace(":00.000Z", "")).replaceAll("-", "/")
            }))
        );


        // setHeadCells(headCells?.find(item => item.id === 'p1').label = `คาดการณ์ ${`ณ ${newTimeString0}`}${result?.data?.p1 ? `${newTimeString1}`:``}${result?.data?.p2 ? `| ${newTimeString2}`:``}${result?.data?.p3 ? `| ${newTimeString3}`:``}`)
        setIsLoading(false);
        // console.log(fetchedData);
        // setDateTime(fetchedData[0].province_data.p_datetime);
        // setExpanded([...Array(result.data.length)].map((val) => false));
    };

    const getDataAmphoe = async (id) => {
        // console.log(id);
        setIsLoadingAmphoe(true);
        const response = await fetch(
            fullPath + "/rest/getPm25byAmphoePred3?pv_idn=" + id
        );
        const result = await response.json();
        // console.log(result1)

        setFetchedDataAmphoe(
            result.data.map((amphoe) => ({
                a_name: amphoe.ap_tn,
                a_PM25: parseFloat(amphoe.pm25).toFixed(1),
                a_24PM25: parseFloat(amphoe.pm25Avg24hr).toFixed(1),
                a_id: amphoe.ap_idn,
                p1: parseFloat(amphoe.pred1).toFixed(1),
                p2: parseFloat(amphoe.pred2).toFixed(1),
                p3: parseFloat(amphoe.pred3).toFixed(1),
                a_datetime: amphoe.dt.split("T")[0].concat(" ", amphoe.dt.split("T")[1].replace(":00.000Z", "")).replaceAll("-", "/")

            }))
        );
        setIsLoadingAmphoe(false);
    };

    const getDataTambon = async (id) => {
        // console.log(id);
        setIsLoadingTambon(true);
        const response = await fetch(
            fullPath + "/rest/getPm25byTambonPred3?ap_idn=" + id
        );
        const result = await response.json();

        setFetchedDataTambon(
            result.data.map((tambon) => ({
                t_name: tambon.tb_tn,
                t_PM25: parseFloat(tambon.pm25).toFixed(1),
                t_24PM25: parseFloat(tambon.pm25Avg24hr).toFixed(1),
                t_id: tambon.tb_idn,
                p1: parseFloat(tambon.pred1).toFixed(1),
                p2: parseFloat(tambon.pred2).toFixed(1),
                p3: parseFloat(tambon.pred3).toFixed(1),
                t_datetime: tambon.dt.split("T")[0].concat(" ", tambon.dt.split("T")[1].replace(":00.000Z", "")).replaceAll("-", "/")
            }))
        );
        setIsLoadingTambon(false);
    };


    const getData24 = async (id, level) => {

        var lv_idn = "";
        if (level === "Province") {
            lv_idn = "pv";
        } else if (level === "Amphoe") {
            lv_idn = "ap";
        } else if (level === "Tambon") {
            lv_idn = "tb";
        }

        setOpen(true);
        const response1 = await fetch(
            fullPath + "/rest/getPM25by" + level + "24hrs?" + lv_idn + "_idn=" + id
        );
        const result1 = await response1.json();

        const r1 = result1.graphHistory24hrs;


        var alldata = []; //อาจต้องเปลี่ยนเป็น setState
        var alltime = []; //อาจต้องเปลี่ยนเป็น setState

        let n, m = 0;

        for (var i = 0; i < r1.length; i++) {
            // { y: parseInt(Data[i]), color: '#FF0000' }
            let thisValue = parseFloat(r1[i][0].toFixed(1));
            let thisColor = '#FFF';

            if (thisValue <= 15.0) {
                thisColor = "#4AC3FF96";
            } else if (thisValue <= 25.0) {
                thisColor = "#90DB4196";
            } else if (thisValue <= 37.5) {
                thisColor = "#FFD34796";
            } else if (thisValue <= 75.0) {
                thisColor = "#FF984A96";
            } else {
                thisColor = "#C03A3096";
            }
            alldata.push({ y: thisValue, color: thisColor });

            alltime.push(r1[i][1].split("T")[1].replace(":00.000Z", " น."));
            n++;
        }

        const response2 = await fetch(
            fullPath + "/rest/pred/getPM25by" + level + "?" + lv_idn + "_idn=" + id
        );
        const result2 = await response2.json();

        const r2 = result2.graphPredictByHrs;

        for (var i = 0; i < r2.length; i++) {
            // { y: parseInt(Data[i]), color: '#FF0000' }
            let thisValue = parseFloat(r2[i][0].toFixed(1));
            let thisColor = '#FFF';

            if (thisValue <= 15.0) {
                thisColor = "#4AC3FF96";
            } else if (thisValue <= 25.0) {
                thisColor = "#90DB4196";
            } else if (thisValue <= 37.5) {
                thisColor = "#FFD34796";
            } else if (thisValue <= 75.0) {
                thisColor = "#FF984A96";
            } else {
                thisColor = "#C03A3096";
            }
            alldata.push({ y: thisValue, color: thisColor });

            alltime.push(`(คาดการณ์) ${r2[i][1].split("T")[1].replace(":00.000Z", " น.")}`);
            m++;
        }

        setAllData(alldata);
        setAllTime(alltime);

        setcData([n, m]);

        // console.log(alldata);

        setIsLoading24(false);
    };

    const options0 = {
        accessibility: {
            enabled: true
        },
        // rangeSelector: {
        //     selected: 1
        // },
        credits: {
            enabled: false
        },
        title: {
            text: '',
            align: 'left'
        },
        yAxis: {
            visible: true,
            title: {
                text: 'PM 2.5 (µg/m³)'
            },
            min: 0,
        },
        xAxis: {
            visible: false,
            categories: allTime0,
            plotBands: [
                { from: allTime0.length - cData0[1] - 0.5, to: allTime0.length - 0.5, color: '#EEE' },
            ],
        },

        legend: {
            enabled: false
        },

        // legend: {
        //   layout: 'vertical',
        //   align: 'center',
        //   verticalAlign: 'top'
        // },
        chart: {
            backgroundColor: 'transparent',
            type: 'column',
            // zoomType: 'x',
            // panning: true,
            // panKey: 'shift'
        },
        plotOptions: {
            // spline: {
            //     marker: {
            //         radius: 4,
            //         lineColor: '#666666',
            //         lineWidth: 1
            //     }
            // },
            series: {
                // borderRadius: {
                //     radius: 3
                // },
                borderRadius: 3,
                borderWidth: 0.25,
                // pointWidth: 15
            },
        },
        series: [{
            animation: false,
            name: 'PM 2.5 (µg/m³)',
            data: allData0,
            borderColor: '#000',
            // color: '#ffa500'
        }],

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 350
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        }

    }

    const options1 = {
        credits: {
            enabled: false
        },
        title: {
            text: '',
            align: 'left'
        },
        yAxis: {
            title: {
                text: 'PM 2.5 (µg/m³)'
            },
            min: 0
        },
        xAxis: {
            labels: {
                enabled: false//default is true
            },
            categories: allTime,
            plotBands: [
                { from: allTime.length - cData[1] - 0.5, to: allTime.length - 0.5, color: '#EEE' },
            ],
        },

        // legend: {
        //   layout: 'vertical',
        //   align: 'center',
        //   verticalAlign: 'top'
        // },
        chart: {
            type: 'column',
            // zoomType: 'x',
            // panning: true,
            // panKey: 'shift'
        },
        plotOptions: {
            // spline: {
            //     marker: {
            //         radius: 4,
            //         lineColor: '#666666',
            //         lineWidth: 1
            //     }
            // },
            series: {
                // borderRadius: {
                //     radius: 3
                // },
                borderRadius: 3,
                borderWidth: 0.25,
                // pointWidth: 15
            },
        },
        series: [{
            name: 'PM 2.5 (µg/m³)',
            data: allData,
            borderColor: '#000',
            // color: '#ffa500'
        }],

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 350
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        }

    }


    // const [data, setdata] = useState();
    // const options = {};


    // const handleClick = (index, id) => {
    //     setExpanded(
    //         expanded.map((boolean_value, i) => {

    //             if (index === i) {
    //                 // once we retrieve the collapse index, we negate it
    //                 if (!boolean_value) {
    //                     setPVID(id);
    //                     getDataAmphoe();
    //                     // setIsLoadingAmphoe(true);
    //                 }
    //                 return !boolean_value;
    //             } else {
    //                 // all other collapse will be closed
    //                 return false;
    //             }
    //         })
    //     );

    // };

    const props = {
        request: "GetMap",
        service: "WMTS",
        version: "1.3",
        format: "image/png",
        layers: "0",
        transparent: true,
    };

    const useStyles = makeStyles((theme) => ({
        root: {

            borderRadius: (props) => {
                return "5px";
            },
            paddingTop: (props) => {
                return "4px";
            },
            paddingBottom: (props) => {
                return "4px";
            },
            paddingLeft: (props) => {
                return "4px";
            },
            paddingRight: (props) => {
                return "4px";
            },
            width: (props) => {
                return "60px";
            },
            height: (props) => {
                return "25px";
            },
            textAlign: (props) => {
                return "center";
            },
            background: (props) => {
                if (props.value <= 15.0) {
                    return "#4AC3FF96";
                } else if (props.value > 15.0 && props.value <= 25.0) {
                    return "#90DB4196";
                } else if (props.value > 25.0 && props.value <= 37.5) {
                    return "#FFD34796";
                } else if (props.value > 37.5 && props.value <= 75.0) {
                    return "#FF984A96";
                } else {
                    return "#C03A3096";
                }
            },
        },
        openButton: {
            color: '#fff',
        }
    }));
    const StyledTableCell = (props) => {
        const classes = useStyles(props);
        return (
            <TableCell
                classes={{ root: classes.root }}
            >
                {props.children}
            </TableCell>
        );
    };

    useEffect(() => {
        // mapRef.current = map; // Assign the map to the ref when available
        // handleOpenX();
        getUserLocation();
        setIsLoadingMap(true);
        setIsLoading(true);
        setIsLoadingAmphoe(true);
        setIsLoadingTambon(true);
        getData();
        getUrl();

        setOpenHotspot(true);
        setOpenProvince(false);

        setBasemap(1);
        setsBasemap(1);

        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };
        window.addEventListener('resize', handleWindowResize);

        if (!urlPM25) return;


        // //-- sphere --//
        // sphere = window.sphere;
        // map = new sphere.Map({ placeholder: document.getElementById('map-sphere'), zoomRange: { min: 0, max: 12 }, });
        // map._this = this;

        // map.Event.bind("ready", function () {
        //     map.bound({ minLon: 97.343699, minLat: 5.612738, maxLon: 105.636781, maxLat: 20.464926 }, { padding: { top: 7, bottom: 7 } });
        //     map.Ui.DPad.visible(false);
        //     map.Ui.LayerSelector.visible(false);
        //     // map.Ui.Geolocation.visible(false);
        //     // map.Ui.Zoombar.visible(false);

        //     // let layer_pm25 = new sphere.Layer('pm25:pm25_hourly_raster', {
        //     let layer_24pm25 = new sphere.Layer('0', {
        //         type: sphere.LayerType.WMS,
        //         url: urlPM2524,
        //         zoomRange: { min: 1, max: 12 },
        //         zIndex: 5,
        //         opacity: 0.8,
        //         id: 'layer_24pm25'
        //     });

        //     let province = new sphere.Layer('0', {
        //         type: sphere.LayerType.WMS,
        //         url: urlProvince,
        //         zoomRange: { min: 1, max: 12 },
        //         zIndex: 6,
        //         opacity: 1,
        //         id: 'province'
        //     });

        //     // let layer_24pm25 = new sphere.Layer('0', {
        //     //     type: sphere.LayerType.WMS,
        //     //     url: "https://gistdaportal.gistda.or.th/data/services/pm_check/pm25_hourly_raster_24hr/MapServer/WMSServer",
        //     //     zoomRange: { min: 1, max: 12 },
        //     //     zIndex: 5,
        //     //     opacity: 0.8,
        //     //     id: 'layer_24pm25'
        //     // });

        //     // setTimeout(() => {
        //     map.Layers.add(layer_24pm25);
        //     map.Layers.add(province);
        //     console.log('add');
        //     // }, 1000);


        //     // map.Layers.add(hotspot);
        // });
        setIsLoadingMap(false);

        // map.Event.bind(sphere.EventName.Click, function (location) {
        //     // console.log(location);
        //     // getDataLocation(location.lon, location.lat);
        //     map.mouseLocation = location;
        // });

        const interval = setInterval(() => {
            // setDateTime(new Date());
            if (0) {
                reloadData();
                goHome();
            }
        }, 600000); //set your time here. repeat every 10 mins

        return () => {
            window.removeEventListener('resize', handleWindowResize);
            clearInterval(interval);
        };
    }, [map]);

    const reloadData = async () => {
        setIsLoading(true);
        getData();
        // console.log([...fetchedData]
        //     .sort(getComparator(order, orderBy))
        //     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
        // console.log(fetchedData);
    };

    const goHome = async () => {
        // console.log(selectedArea)
        getBbox(selectedArea?.id);
        getDataArea(selectedArea?.id);

        // map.bound({ minLon: 97.343699, minLat: 5.612738, maxLon: 105.636781, maxLat: 20.464926 }, { padding: { top: 7, bottom: 7 } });
    }

    const toggleBasemap = async (i) => {
        setBasemap(sBasemap);
        var url = [
            urlPM2524,
            urlPM25

            // "https://tile.gistda.or.th/geoserver/pm25/wms",
            // "https://tile.gistda.or.th/geoserver/pm25/wms"
        ]

        // console.log(url[basemap]);

        // // let layer_pm25 = new sphere.Layer('pm25:pm25_hourly_raster', {
        // let layer_pm25 = new sphere.Layer('0', {
        //     type: sphere.LayerType.WMS,
        //     url: urlPM25,
        //     zoomRange: { min: 1, max: 12 },
        //     zIndex: 5,
        //     opacity: 0.8,
        //     id: 'layer_pm25'
        // });

        // // let layer_24pm25 = new sphere.Layer('pm25:pm25_hourly_raster_24hr', {
        // let layer_24pm25 = new sphere.Layer('0', {
        //     type: sphere.LayerType.WMS,
        //     url: urlPM2524,
        //     zoomRange: { min: 1, max: 12 },
        //     zIndex: 5,
        //     opacity: 0.8,
        //     id: 'layer_24pm25'
        // });

        // { i === 1 ? map.Layers.add(layer_pm25) : map.Layers.remove(layer_pm25) }
        // { i === 0 ? map.Layers.add(layer_24pm25) : map.Layers.remove(layer_24pm25) }

    }

    const removeHotspot = async () => {
        // let hotspot = new sphere.Layer(['0', '1'], {
        //     type: sphere.LayerType.WMS,
        //     url: urlHotspot,
        //     zoomRange: { min: 1, max: 12 },
        //     zIndex: 10,
        //     opacity: 0.6,
        //     id: 'hotspot'
        // });

        // { openHotspot ? map.Layers.add(hotspot) : map.Layers.remove(hotspot) }
        setOpenHotspot(!openHotspot);
    }

    // const removeProvine = async () => {
    //     let province = new sphere.Layer('0', {
    //         type: sphere.LayerType.WMS,
    //         url: "https://gistdaportal.gistda.or.th/data2/services/L05_Province_GISTDA_50k_nonlabel/MapServer/WMSServer",
    //         zoomRange: { min: 1, max: 12 },
    //         zIndex: 6,
    //         opacity: 1,
    //         id: 'province'
    //     });

    //     { openProvince ? map.Layers.add(province) : map.Layers.remove(province) }
    //     setOpenProvince(!openProvince);
    // }

    // const getDataLocation = async (lon, lat) => {
    //     const response = await fetch(
    //         "https://pm25-cloud-run-anqwcyx7xa-as.a.run.app/rest/getPm25byLocation?lat=" + lat + "&lng=" + lon
    //     );
    //     const result = await response.json();



    //     setFetchedDataLoc(
    //         result.data.map((data) => ({
    //             data: {
    //                 d_name: data.loc.loctext,
    //                 d_PM25: parseFloat(data.pm25).toFixed(1),
    //                 d_24PM25: parseFloat(data.pm25Avg24hr).toFixed(1),
    //                 d_datetime: data.datetimeThai.dateThai.concat(" ", data.datetimeThai.timeThai)
    //             }
    //         }))
    //     );

    //     console.log(fetchedDataLoc);

    //     setIsLoading(false);



    //     // map.Event.bind(sphere.EventName.Click, function(location) {
    //     //     console.log(location);
    //     //     map.mouseLocation = location;
    //     //   });
    // }



    return (
        <div className="App" style={{ marginTop: 141 }}>

            {/* handleCloseAds */}




            {/* <ThemeProvider theme={light ? themeLight : themeDark}> */}

            {/* <h2>Height: {windowSize[1]}</h2> */}
            <Grid container spacing={{ xs: 3 }} >


                <Grid item xs={1}>
                    <Item></Item>
                </Grid>

                <Grid item xs={10}>
                    <Typography fontSize={12}>พิมพ์ค้นหาด้วยชื่อ ตำบล อำเภอ หรือจังหวัด และดูข้อมูล PM2.5 ทั่วประเทศไทยได้ที่ตารางด้านล่าง</Typography>
                    <Autocomplete
                        value={selectedArea}
                        onInputChange={(event, newValue, reason) => {
                            if (reason === 'reset') {
                                // getUserLocation();
                                // return
                            } else if (reason === 'input' && newValue?.length > 1) {
                                getName(newValue);
                            }
                        }}
                        onChange={(event, newValue) => {
                            // if (newValue.length > 1) {
                            // console.log(newValue?.id)
                            setSelectedArea(newValue);
                            // setSelectedID(newValue?.id);
                            getBbox(newValue?.id);
                            getDataArea(newValue?.id);
                            // }
                        }}

                        sx={{ width: '100%', bgcolor: '#FFF', WebkitTextFillColor: "#000", borderRadius: 10 }}
                        open={openAuto}
                        onOpen={() => {
                            setOpenAuto(true);
                        }}
                        onClose={() => {
                            setOpenAuto(false);
                        }}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        getOptionLabel={(option) => option?.name || ''}
                        options={areaList}
                        loading={isLoadingName}
                        noOptionsText={'ไม่มีข้อมูล'}
                        renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                                <div>{option.name_th}</div>

                                <div style={{ fontSize: '0.8em', color: 'gray', padding: 1 }}>
                                    {option.name_en}
                                </div>
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                // sx={{ bgcolor: 'theme.palette.default' }}
                                {...params}
                                label="ค้นหาด้วยชื่อ ตำบล อำเภอ หรือจังหวัดของคุณ"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {isLoadingName ? <CircularProgress color="primary" size={28} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={1} />

                <Box alignContent={'center'} sx={{
                    display: openAds ? 'block' : 'none',
                    width: windowSize[0] > 400 ? '400px' : windowSize[0] * 0.9,
                    height: { xs: '100px', sm: '200px' },
                    minHeight: 'auto',
                    position: 'fixed',
                    bottom: 10,
                    right: 10,
                    borderRadius: 5,
                    color: '#21367C',
                    backgroundColor: '#FFF',
                    outline: '2px solid rgba(0, 0, 0, 0.1)',
                    boxShadow: 3,
                    fontSize: 12,
                    zIndex: 999,
                }}>
                    <Box onClick={() => handleCloseAds()} sx={{
                        minHeight: 'auto',
                        position: 'absolute',
                        top: -25,
                        left: -25,
                        zIndex: 999,
                    }}>
                        <img lang='th' src={x} alt="กดเพื่อปิด" aria-label="กดเพื่อปิด"></img>
                    </Box>
                    <Box sx={{
                        display: { xs: 'none', sm: 'block' },
                        minHeight: 'auto',
                        position: 'absolute',
                        bottom: 20,
                        right: 20,
                        zIndex: 999,
                    }}>
                        <img lang='th' src={phonePic} alt="ภาพโทรศัพท์สมาร์ทโฟน" aria-label="ภาพโทรศัพท์สมาร์ทโฟน"></img>
                    </Box>
                    <Box sx={{
                        display: { xs: 'none', sm: 'block' },
                        minHeight: 'auto',
                        position: 'absolute',
                        top: 20,
                        left: 25,
                        zIndex: 999,
                    }}>
                        <img lang='th' src={logoIcon} alt="ภาพตราเช็คฝุ่น" aria-label="ภาพตราเช็คฝุ่น"></img>
                    </Box>
                    <Typography fontSize={14} sx={{
                        minHeight: 'auto',
                        position: 'absolute',
                        top: { xs: 10, sm: 65 },
                        left: 25,
                        zIndex: 999,
                    }}>
                        แอปพลิเคชัน
                    </Typography>
                    <Typography fontSize={12} sx={{
                        minHeight: 'auto',
                        position: 'absolute',
                        bottom: 55,
                        left: 25,
                        zIndex: 999,
                    }}>
                        ดาวน์โหลดเลย
                    </Typography>
                    <Box sx={{
                        minHeight: 'auto',
                        position: 'absolute',
                        bottom: 20,
                        left: 25,
                        zIndex: 999,
                    }}>
                        <a target="_blank" href="https://apps.apple.com/th/app/เช-คฝ-น/id1591356571" aria-label="คลิกเพื่อดาวน์โหลดแอปพลิเคชั่นเช็คฝุ่นผ่านแอปสโตร์ (iOS)">
                            <img lang='th' src={aapl} alt="คลิกเพื่อดาวน์โหลดแอปพลิเคชั่นเช็คฝุ่นผ่านแอปสโตร์ (iOS)" aria-label="คลิกเพื่อดาวน์โหลดแอปพลิเคชั่นเช็คฝุ่นผ่านแอปสโตร์ (iOS)" />
                        </a>
                    </Box>
                    <Box sx={{
                        minHeight: 'auto',
                        position: 'absolute',
                        bottom: 20,
                        left: 135,
                        zIndex: 999,
                    }}>
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.gistda.pm25check" aria-label="คลิกเพื่อดาวน์โหลดแอปพลิเคชั่นเช็คฝุ่นผ่านกูเกิลเพลย์ (แอนดรอยด์)">
                            <img lang='th' src={googl} alt="คลิกเพื่อดาวน์โหลดแอปพลิเคชั่นเช็คฝุ่นผ่านกูเกิลเพลย์ (แอนดรอยด์)" aria-label="คลิกเพื่อดาวน์โหลดแอปพลิเคชั่นเช็คฝุ่นผ่านกูเกิลเพลย์ (แอนดรอยด์)" />
                        </a>
                    </Box>
                </Box>

                <Grid item xs={1} />

                <Grid item xs={10} md={6}>

                    <Grid item>

                        <Box position={'relative'} sx={{ height: { sm: 520, xs: 260 }, }}>

                            <MapContainer
                                ref={setMap}
                                // center={[13.15, 101]}
                                bounds={bbox}
                                // zoom={5} 
                                style={{ minHeight: "100%", borderRadius: 20 }} id='leaflet-container'>
                                {/* <Fab size='small' sx={{
                                    width: '29px',
                                    height: '25px',
                                    minHeight: 'auto',
                                    position: 'absolute',
                                    top: 144,
                                    left: 10,
                                    borderRadius: 1,
                                    color: '#21367C',
                                    backgroundColor: '#FFF',
                                    outline: '2px solid rgba(0, 0, 0, 0.1)',
                                    boxShadow: 0,
                                }}>
                                    <HomeIcon
                                        onClick={() => goHome()} />
                                </Fab> */}

                                <Box alignContent={'center'} sx={{
                                    width: '250px',
                                    height: '25px',
                                    minHeight: 'auto',
                                    position: 'absolute',
                                    bottom: 40,
                                    right: 10,
                                    borderRadius: 1,
                                    color: '#21367C',
                                    backgroundColor: '#FFF',
                                    outline: '2px solid rgba(0, 0, 0, 0.1)',
                                    boxShadow: 0,
                                    fontSize: 12,
                                    zIndex: 998,
                                }}>
                                    <Typography fontSize={12}>
                                        {basemap === 1 ? `ข้อมูล PM2.5 เฉลี่ย 24 ชั่วโมง ${isLoading ? '' : `ณ ${lastDt.timeThai}`}` : `ข้อมูล PM2.5 รายชั่วโมง ${isLoading ? '' : `ณ ${lastDt.timeThai}`}`}
                                    </Typography>
                                </Box>

                                {openHotspot ? '' : <Box alignContent={'center'} sx={{
                                    width: '250px',
                                    height: '25px',
                                    minHeight: 'auto',
                                    position: 'absolute',
                                    bottom: 70,
                                    right: 10,
                                    borderRadius: 1,
                                    color: '#21367C',
                                    backgroundColor: '#FFF',
                                    outline: '2px solid rgba(0, 0, 0, 0.1)',
                                    boxShadow: 0,
                                    zIndex: 998,
                                    fontSize: 12,
                                }}>
                                    <Typography fontSize={12}>
                                        🔴 จุดความร้อนสะสม 24 ชั่วโมง (ระบบ VIIRS)
                                    </Typography>
                                </Box>}

                                <Box alignContent={'center'} sx={{
                                    position: 'absolute',
                                    bottom: 15,
                                    left: 10,
                                    zIndex: 998,
                                    maxWidth: windowSize[0] * 0.75,
                                }}>
                                    <img lang='th' width={'100%'} src={colorbarPic} alt="แถบสี สีฟ้า(ดีมาก), สีเขียว(ดี), สีเหลือง(ปานกลาง), สีส้ม(เริ่มมีผล), สีแดง(มีผล)"
                                        aria-label="แถบสี สีฟ้า(ดีมาก), สีเขียว(ดี), สีเหลือง(ปานกลาง), สีส้ม(เริ่มมีผล), สีแดง(มีผล)"></img>
                                </Box>

                                <Fab lang='th' size='small' aria-label="เปิด/ปิดชั้นข้อมูลแสดงแผนที่จุดความร้อน" sx={{
                                    width: '29px',
                                    height: '25px',
                                    minHeight: 'auto',
                                    position: 'absolute',
                                    top: 48,
                                    right: 10,
                                    borderRadius: 1,
                                    color: '#21367C',
                                    backgroundColor: '#FFF',
                                    outline: '2px solid rgba(0, 0, 0, 0.1)',
                                    boxShadow: 0,

                                }}>
                                    <Tooltip title={"จุดความร้อน"}>
                                        <LocalFireDepartmentIcon
                                            color={openHotspot ? "primary" : "secondary"} variant="contained" onClick={removeHotspot} />
                                    </Tooltip>
                                </Fab>

                                <Fab lang='th' size='small' aria-label="สลับชั้นข้อมูลแสดงแผนที่ข้อมูลPM2.5เฉลี่ยรายวัน/รายชั่วโมง" sx={{
                                    width: '29px',
                                    height: '25px',
                                    minHeight: 'auto',
                                    position: 'absolute',
                                    top: 78,
                                    right: 10,
                                    borderRadius: 1,
                                    color: '#21367C',
                                    backgroundColor: '#FFF',
                                    outline: '2px solid rgba(0, 0, 0, 0.1)',
                                    boxShadow: 0,

                                }}>
                                    <Tooltip title={"ชั้นข้อมูล PM2.5"}>
                                        <LayersIcon
                                            color={basemap === 1 ? "primary" : "secondary"} variant="contained" onClick={handleChange} />
                                    </Tooltip>
                                </Fab>

                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />

                                {/* <TileLayer
                                    attribution='&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
                                    url="http://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/%7Bz%7D/%7By%7D/%7Bx%7D"
                                /> */}

                                {!openHotspot ?
                                    <WMSTileLayer
                                        zIndex={3}
                                        layers={['0', '1']}
                                        url={urlHotspot}
                                        // maxZoom={12}
                                        transparent={true}
                                        format='image/png'
                                        opacity={0.8}
                                    />
                                    :
                                    ''
                                }
                                {basemap === 0 ?
                                    <WMSTileLayer
                                        zIndex={1}
                                        layers={['0']}
                                        url={urlPM25}
                                        // maxZoom={12}
                                        transparent={true}
                                        format='image/png'
                                        opacity={0.9}
                                    />
                                    :
                                    ''
                                }
                                {basemap === 1 ?
                                    <WMSTileLayer
                                        zIndex={1}
                                        layers={['0']}
                                        url={urlPM2524}
                                        // maxZoom={12}
                                        transparent={true}
                                        format='image/png'
                                        opacity={0.9}
                                    />
                                    :
                                    ''
                                }
                                <WMSTileLayer
                                    zIndex={2}
                                    layers={['0']}
                                    url={urlProvince}
                                    // maxZoom={12}
                                    transparent={true}
                                    format='image/png'
                                    opacity={1}
                                />

                            </MapContainer>


                        </Box>


                    </Grid>

                    <Grid item xs={1} md={0}>

                    </Grid>

                </Grid>

                <Grid item xs={12} md={4}>
                    <Box style={{ marginTop: 0, marginBottom: 8 }}>
                        <Typography variant='h5' fontSize={16} fontWeight={700}>ชั่วโมงนี้อากาศเป็นอย่างไร? (PM2.5 ชั่วโมงล่าสุด)</Typography>
                    </Box>

                    <Box height={"fit-content"} sx={{ border: 0, borderRadius: 5, p: 3, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, boxShadow: 3 }} bgcolor={'background.defaults'} lang='th' aria-lebel={'ข้อมูล PM2.5 ตามเกณฑ์'}>
                        {/* ส่วนหัว */}

                        <Box width='100%' sx={{ display: 'flex', justifyContent: 'space-between' }} alignItems={'center'} spacing={1} lang='th' aria-lebel={'ข้อมูล ณ'}>
                            <Box width='100%' sx={{ display: 'flex' }} alignItems={'center'} spacing={1}>
                                <img lang='th' src={pinPic} alt=''></img>
                                <Typography fontWeight={600} padding={1}>{!fetchedDataLocation?.pm25 ? 'กำลังดาวน์โหลด...' : fetchedDataLocation?.loc ? `${fetchedDataLocation?.loc?.loctext}` : selectedArea?.name_th?.split(' << ').reverse().join(' ')}</Typography>
                                <Typography fontSize={8}>{userLocation && fetchedDataLocation?.loc ? `(${userLocation.latitude.toFixed(4)}, ${userLocation.longitude.toFixed(4)})` :
                                    selectedArea?.name_th ? '' :
                                        '*ไม่สามารถเข้าถึงตำแหน่งอุปกรณ์ของผู้ใช้'}
                                </Typography>
                            </Box>

                            <IconButton aria-label="คำอธิบาย" onClick={handleOpenI}>
                                <InfoIcon aria-label="คำอธิบาย" style={{ color: 'black' }} />
                            </IconButton>
                        </Box>
                        <Box width='100%' display="flex" alignItems="center" flexDirection={'row'} paddingTop={1} sx={{ justifyContent: 'center' }} lang='th' aria-lebel={'ข้อมูล PM2.5'}>
                            <Box display="flex" alignItems="center" flexDirection={'column'} spacing={1}>
                                <Box>
                                    {!fetchedDataLocation?.pm25 ? <CircularProgress /> : fetchedDataLocation.pm25 <= 15.0 ? <img lang='th' src={color1Pic} alt="หน้ายิ้มสีฟ้า (ดีมาก)"></img> :
                                        fetchedDataLocation.pm25 <= 25.0 ? <img lang='th' src={color2Pic} alt="หน้ายิ้มสีเขียว (ดี)"></img> :
                                            fetchedDataLocation.pm25 <= 37.5 ? <img lang='th' src={color3Pic} alt="หน้าใส่หน้ากากสีเหลือง (ปานกลาง)"></img> :
                                                fetchedDataLocation.pm25 <= 75.0 ? <img lang='th' src={color4Pic} alt="หน้าใส่หน้ากากสีส้ม (เริ่มมีผล)"></img> :
                                                    fetchedDataLocation.pm25 > 75.0 ? <img lang='th' src={color5Pic} alt="หน้าใส่หน้ากากสีแดง (มีผล)"></img> :
                                                        ''}
                                </Box>
                                <Box borderRadius={5} minHeight={32} minWidth={143} alignContent={'center'}
                                    bgcolor={!fetchedDataLocation?.pm25 ? '' :
                                        fetchedDataLocation.pm25 <= 15.0 ? "#4AC3FF96" :
                                            fetchedDataLocation.pm25 <= 25.0 ? "#90DB4196" :
                                                fetchedDataLocation.pm25 <= 37.5 ? "#FFD34796" :
                                                    fetchedDataLocation.pm25 <= 75.0 ? "#FF984A96" :
                                                        fetchedDataLocation.pm25 > 75.0 ? "#C03A3096" :
                                                            ''}>
                                    <Typography padding={1} fontWeight={'700'}>คุณภาพอากาศ{!fetchedDataLocation?.pm25Avg24hrs ? '' :
                                        fetchedDataLocation.pm25 <= 15.0 ? "ดีมาก" :
                                            fetchedDataLocation.pm25 <= 25.0 ? "ดี" :
                                                fetchedDataLocation.pm25 <= 37.5 ? "ปานกลาง" :
                                                    fetchedDataLocation.pm25 <= 75.0 ? "เริ่มมีผลต่อสุขภาพ" :
                                                        fetchedDataLocation.pm25 > 75.0 ? "มีผลต่อสุขภาพ" :
                                                            ''}</Typography>
                                </Box>
                            </Box>
                            <Box display="flex" alignItems="center" flexDirection={'column'}>
                                <Box borderRadius={5} minHeight={32} minWidth={143} alignContent={'center'}
                                >
                                    <Typography fontSize={72}

                                    >{fetchedDataLocation?.pm25 ? `${fetchedDataLocation?.pm25?.toFixed(1)}` : ''}
                                    </Typography>
                                </Box>
                                <Typography fontSize={24}>µg/m³</Typography>
                            </Box>
                        </Box>
                        <Box paddingTop={1}>
                            <Typography fontSize={8} >*ข้อมูลแจ้งเตือนอย่างเป็นทางการ โปรดอ้างอิง Air4Thai และ AirBKK</Typography>
                        </Box>

                    </Box>
                    <Box height={"fit-content"} sx={{ flex: 1, border: 0, borderRadius: 5, p: 1, borderTopLeftRadius: 0, borderTopRightRadius: 0, boxShadow: 3 }} bgcolor={"#F0F5FA"} color='#000' lang='th' aria-lebel='สภาพอากาศ'>
                        <Grid container spacing={1} xs={12} >
                            <Grid item xs={4}>
                                {/* <Box item fullWidth display="flex" alignItems="center" flexDirection={'row'}> */}

                                <Typography> <img lang='th' src={Wt1} height={16} alt='อุณหภูมิ' />{fetchedDataWeatherLocation?.temperature_2m ? `${fetchedDataWeatherLocation?.temperature_2m.toFixed(1)}° C` : 'ไม่มีข้อมูล'} </Typography>
                                {/* </Box> */}
                            </Grid>
                            <Grid item xs={4}>
                                {/* <Box display="flex" alignItems="center" flexDirection={'row'}> */}

                                <Typography> <img lang='th' src={Wt2} height={16} alt='โอกาสฝนตก' /> {fetchedDataWeatherLocation?.temperature_2m ? `${fetchedDataWeatherLocation?.precipitation_probability_max.toFixed(0)}%` : 'ไม่มีข้อมูล'} </Typography>
                                {/* </Box> */}
                            </Grid>
                            <Grid item xs={4}>
                                {/* <Box display="flex" alignItems="center" flexDirection={'row'}> */}

                                <Typography> <img lang='th' src={Wt3} height={16} alt='ความเร็วลม' />{fetchedDataWeatherLocation?.temperature_2m ? `${fetchedDataWeatherLocation?.windspeed_10m_max.toFixed(1)} กม./ชม.` : 'ไม่มีข้อมูล'} </Typography>
                                {/* </Box> */}
                            </Grid>
                        </Grid>
                    </Box>

                    <div style={{ marginTop: 16, marginBottom: 8 }}>
                        <Typography lang='th'>สถิติรายชั่วโมงและคาดการณ์
                            {/* <Button variant='contained'
                                style={{ borderRadius: 50 }} target="_blank" href={fullPath + '/rest/get/report.pdf'}>PDF</Button> */}
                        </Typography>

                    </div>

                    <Box height={150} sx={{ border: 0, borderRadius: 5, p: 1, boxShadow: 3, alignContent: 'center' }} bgcolor={'background.defaults'} >
                        {/* ส่วนหัว */}


                        {/* <Typography >{userLocation ? `${userLocation.latitude} ${userLocation.longitude}` : isLoadingLocation ? 'na' : 'ไม่พบข้อมูลตำแหน่งปัจจุบัน'} </Typography> */}

                        {/* ส่วนข้อมูลเพิ่มเติม */}
                        {/* <Grid container spacing={1}> */}
                        {/* <Grid item xs={3}>
                                <Typography> {fetchedDataWeatherLocation ? `${fetchedDataWeatherLocation?.temperature_2m}° C` : 'na'} </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography> {fetchedDataWeatherLocation ? `${fetchedDataWeatherLocation?.precipitation_probability_max}%` : 'na'} </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography> {fetchedDataWeatherLocation ? `${fetchedDataWeatherLocation?.temperature_2m} กม./ชม.` : 'na'} </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography> {fetchedDataWeatherLocation ? `${fetchedDataWeatherLocation?.temperature_2m} กม./ชม.` : 'na'} </Typography>
                            </Grid> */}
                        {/* </Grid> */}

                        {/* ส่วนกราฟ */}

                        <Box height={100} lang='th' aria-label='ข้อมูล PM2.5 รายชั่วโมง และคาดการณ์'>
                            {isLoadingLocation ? <CircularProgress /> :
                                <HighchartsReact
                                    containerProps={{ style: { height: "100%", width: "100%" } }}
                                    highcharts={Highcharts}
                                    options={options0}
                                />}
                            <Typography fontSize={12} >เฉลี่ย 24 ชั่วโมงต่อเนื่อง = {fetchedDataLocation?.pm25Avg24hrs?.toFixed(1)} µg/m³</Typography>

                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={1} />

                <Grid item xs={1} />

                <Grid item xs={12} md={10}>
                    <Stack spacing={1} padding={1} direction="row">
                        {/* <Button color={openHotspot ? "primary" : "secondary"} variant="contained" onClick={removeHotspot}>{openHotspot ? "เปิด" : "ปิด"}จุดความร้อนสะสม 24 ชม (ระบบ VIIRS)</Button> */}
                        {/* <Button color={openProvince ? "primary" : "secondary"} variant="contained" onClick={removeProvine}>{openProvince ? "เปิด" : "ปิด"}ชั้นข้อมูลขอบเขตจังหวัด</Button> */}
                        {/* <Button color="primary" variant="contained" onClick={toggleBasemap}>ข้อมูลราย{basemap === 0 ? "" : "24"}ชั่วโมง</Button> */}
                        {/* <Box sx={{ minWidth: 120 }}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">แผนที่</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={sBasemap}
                                    label="แผนที่"
                                    onChange={handleChange}
                                >
                                    <MenuItem value={0}>รายชั่วโมง</MenuItem>
                                    <MenuItem value={1}>เฉลี่ย 24 ชั่วโมง</MenuItem>
                                </Select>
                            </FormControl>
                        </Box> */}
                    </Stack>

                    <Stack padding={1}>

                        <div lang='th'>
                            <Typography variant='h5' fontSize={18} lang='th'>
                                {isLoading ? `Loading...` : `ข้อมูลล่าสุด ณ ${lastDt.dateThai} ${lastDt.timeThai}`} {isLoading ? '' :
                                    <IconButton lang='th' aria-label='อัพเดทข้อมูลล่าสุด' onClick={() => { reloadData(true); }}>
                                        <RestartAltIcon />
                                    </IconButton>}
                            </Typography>

                            {/* {isLoading ? `` : <FormControlLabel control={<Switch size="small"/>} label="Auto Reload" />} */}

                            {/* <Button onClick={() => Axios({
                                url: fullPath + '/rest/get/report.pdf',
                                method: 'GET',
                                responseType: 'blob', // Important
                            }).then((response) => {
                                FileDownload(response.data, 'PM25_report.pdf');
                            })}>รายงานภาพรวม PDF</Button> */}
                        </div>
                        {/* <div>
                            {isLoading ? '' : `คาดการณ์ ณ ${predDt[0]}`}
                        </div> */}
                        <Box sx={{ width: '100%' }}>
                            <Paper sx={{ width: '100%', mb: 2 }}>
                                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                                <TableContainer sx={{
                                    maxHeight: 730,
                                    "&::-webkit-scrollbar": {
                                        width: 5,
                                        height: 5
                                    },
                                    "&::-webkit-scrollbar-track": {
                                        backgroundColor: "#e2f1ff"
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                        backgroundColor: "#0080ff",
                                        borderRadius: 2
                                    },
                                    "&::-webkit-scrollbar-thumb:hover": {
                                        background: "#1c5bd8"
                                    }
                                }}>
                                    <Table stickyHeader
                                        sx={{ bgcolor: "background.default", minWidth: 750 }}
                                        lang='th'
                                        aria-labelledby="ตารางแสดงค่า PM2.5"
                                        size={dense ? 'small' : 'medium'}
                                    >
                                        <EnhancedTableHead
                                            order={order}
                                            orderBy={orderBy}
                                            onRequestSort={handleRequestSort}
                                            rowCount={fetchedData.length}
                                        >
                                            {/* <TableRow>

                                                <TableCell component="th" sx={{ width: 120 }}>จังหวัด</TableCell>
                                                <TableCell component="th" sx={{ width: 120 }} align="center"> <div>ชั่วโมงล่าสุด<br />(µg/m³)</div> </TableCell>
                                                <TableCell component="th" sx={{ width: 120 }} align="center"> <div>คาดการณ์<br />{isLoading ? '' : `ณ ${predDt[0]}`}<br />{isLoading ? '' : `${fetchedData.length > 0 && fetchedData[0].p1 * 0 === 0 ? `${predDt[1]} |` : ''} ${fetchedData.length > 0 && fetchedData[0].p2 * 0 === 0 ? `${predDt[2]} |` : ''} ${fetchedData.length > 0 && fetchedData[0].p3 * 0 === 0 ? `${predDt[3]}` : ''} `}</div> </TableCell>
                                                <TableCell component="th" sx={{ width: 120 }} align="center"> <div>เฉลี่ย<br />24 ชั่วโมง<br />(µg/m³)</div> </TableCell>
                                                <TableCell component="th" sx={{ width: 30 }} align="center">รายอำเภอ</TableCell>
                                                <TableCell component="th" sx={{ width: 30 }} align="center"> <div>ข้อมูล<br />กราฟ</div> </TableCell>
                                            </TableRow> */}
                                        </EnhancedTableHead>

                                        <TableBody>
                                            {isLoading ? <TableRow>
                                                <TableCell>
                                                    <Skeleton animation="wave" />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton animation="wave" />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton animation="wave" />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton animation="wave" />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton animation="wave" />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton animation="wave" />
                                                </TableCell>
                                            </TableRow>
                                                :
                                                ([...fetchedData]
                                                    .sort(getComparator(order, orderBy))
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)).map((row, index) => {
                                                        // const isItemSelected = selected.includes(row.id);
                                                        const labelId = `enhanced-table-checkbox-${index}`;

                                                        return (
                                                            <StyledTableRow
                                                                // hover
                                                                // onClick={(event) => handleClick(event, row.id)}
                                                                // role="checkbox"
                                                                // aria-checked={isItemSelected}
                                                                // tabIndex={-1}
                                                                key={row.id}
                                                            // selected={isItemSelected}
                                                            // sx={{ cursor: 'pointer' }}
                                                            >
                                                                {/* <TableCell padding="checkbox">
                                                            <Checkbox
                                                                color="primary"
                                                                // checked={isItemSelected}
                                                                inputProps={{
                                                                    'aria-labelledby': labelId,
                                                                }}
                                                            />
                                                        </TableCell> */}
                                                                <TableCell
                                                                    component="td"
                                                                    // id={labelId}
                                                                    scope="row"
                                                                    padding="1"
                                                                >
                                                                    {row.p_name}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <Stack width={'100%'} sx={{ justifyContent: 'center' }} direction="row" spacing={0.25}>
                                                                        <StyledTableCell value={row.p_PM25} component="th" align="center">
                                                                            {row.p_PM25}
                                                                        </StyledTableCell>
                                                                    </Stack>
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <Stack width={'100%'} sx={{ justifyContent: 'center' }} direction="row" spacing={0.25}>
                                                                        {row.p1 * 0 === 0 ?
                                                                            <StyledTableCell value={row.p1} component="th" align="center">
                                                                                {(row.p1 === row.p_PM25 ? '' : (parseFloat(row.p1) > parseFloat(row.p_PM25) ? '' : '')) + row.p1}
                                                                            </StyledTableCell>
                                                                            : ''}
                                                                        {row.p2 * 0 === 0 ?
                                                                            <StyledTableCell value={row.p2} component="th" align="center">
                                                                                {(row.p2 === row.p1 ? '' : (parseFloat(row.p2) > parseFloat(row.p1) ? '' : '')) + row.p2}
                                                                            </StyledTableCell>
                                                                            : ''}
                                                                        {row.p3 * 0 === 0 ?
                                                                            <StyledTableCell value={row.p3} component="th" align="center">
                                                                                {(row.p3 === row.p2 ? '' : (parseFloat(row.p3) > parseFloat(row.p2) ? '' : '')) + row.p3}
                                                                            </StyledTableCell>
                                                                            : ''}
                                                                    </Stack>
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <Stack width={'100%'} sx={{ justifyContent: 'center' }} direction="row" spacing={0.25}>
                                                                        <StyledTableCell value={row.p_24PM25} component="th" align="center">
                                                                            {row.p_24PM25}
                                                                        </StyledTableCell>
                                                                    </Stack>
                                                                </TableCell>
                                                                <TableCell component="td" align="center">
                                                                    {/* <IconButton
                                                        aria-label="expand row"
                                                        size="small"
                                                        onClick={() => handleClick(index, province.province_data.p_id)}

                                                    >
                                                        {expanded[index] ? (
                                                            <KeyboardArrowUpIcon />
                                                        ) : (
                                                            <KeyboardArrowDownIcon />
                                                        )}
                                                    </IconButton> */}
                                                                    <IconButton
                                                                        lang='th'
                                                                        aria-label="กดเพื่อดูรายละเอียดรายอำเภอ"
                                                                        size="small"
                                                                        onClick={() => handleOpenA(row.p_id, row.p_name)}
                                                                    ><FormatListNumberedIcon /></IconButton>
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" align="center">
                                                                    <div>
                                                                        <Button lang='th' aria-label="แสดงกราฟข้อมูลย้อนหลังรายชั่วโมง" onClick={() => handleOpen(row.p_id, 'Province', row.p_name)}>
                                                                            <ShowChartIcon></ShowChartIcon>
                                                                        </Button>
                                                                    </div>
                                                                </TableCell>
                                                            </StyledTableRow>
                                                        );
                                                    })}
                                            {emptyRows > 0 && (
                                                <TableRow
                                                    style={{
                                                        height: (dense ? 33 : 53) * emptyRows,
                                                    }}
                                                >
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {/* <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={fetchedData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                /> */}
                            </Paper>
                            {/* <FormControlLabel
                                control={<Switch checked={dense} onChange={handleChangeDense} />}
                                label="Dense padding"
                            /> */}
                        </Box>

                    </Stack>
                </Grid>

                <Grid item xs={12} sx={{ paddingBottom: "7px" }}>
                    {/* เว็บไซต์เวอร์ชันเก่า: <a target="_blank" href="http://103.156.151.128/pm25">คลิกที่นี่</a> */}
                    {/* ติดต่อเรา Email: innotech@gistda.or.th / Facebook: <a target="_blank" href="https://www.facebook.com/gistda">GISTDA</a> */}
                </Grid>

            </Grid>

            <Modal
                open={openX}
                onClose={handleCloseX}
                lang='th'
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        เรียนผู้ใช้งาน
                        เนื่องด้วยมีการงดจ่ายไฟฟ้าในวันที่ 21-22 ธันวาคม 2567 ซึ่งจะส่งผลต่อการอัปเดทข้อมูลในระบบ เช็คฝุ่น โดยข้อมูลในช่วงวันและเวลาดังกล่าวจะไม่สามารถอัปเดทข้อมูลเป็นปัจจุบันได้ จึงเรียนมาเพื่อทราบและขออภัยในความไม่สะดวกมา ณ โอกาสนี้
                    </Typography>
                    <Button onClick={handleCloseX}>ปิด</Button>
                </Box>
            </Modal>

            <Modal
                open={openI}
                onClose={handleCloseI}
                lang='th'
                aria-labelledby="คำอธิบาย"
                aria-describedby="คำอธิบาย"
            >
                <Box sx={style} spacing={1}>
                    <Typography variant='body1' fontWeight={'blod'}>คำอธิบาย</Typography>

                    <Typography id="modal-modal-title" variant="body2" >
                        ข้อมูล PM2.5 (เช็คฝุ่น) วิเคราะห์ด้วยเทคโนโลยีปัญญาประดิษฐ์ (AI) เป็นการบูรณาการข้อมูลจากดาวเทียม เช่น Himawari , ข้อมูลสภาพอากาศ (กรมอุตุนิยมวิทยา) รวมถึงข้อมูลแหล่งกำเนิดฝุ่น เช่น จุดความร้อน ร่วมกับการปรับเทียบข้อมูล PM 2.5 กับสถานีตรวจวัด (กรมควบคุมมลพิษ)
                    </Typography>
                    {/* <Divider height={2}/> */}
                    <Box paddingTop={1}>
                        <Typography variant='body1' fontWeight={'blod'}>มาตรฐานคุณภาพอากาศของประเทศไทย</Typography>
                        <Typography variant='body2'>PM2.5 เฉลี่ย 24 ชั่วโมงต่อเนื่อง : ไมโครกรัมต่อลูกบาศก์เมตร หรือ มคก./ลบ.ม. หรือ µg./m³ (อ้างอิง <a target="_blank" href="http://air4thai.pcd.go.th/webV3/#/AQIInfo">กรมควบคุมมลพิษ</a>)</Typography>
                        <Table size="small" lang='th' aria-label="เกณฑ์" width='100%'>
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        sx={{ backgroundColor: "#4AC3FF96" }}>
                                        <div className="pm25-class">
                                            ดีมาก
                                        </div>
                                        <div className="pm25-class">
                                            0-15.0 µg/m³
                                        </div>
                                    </TableCell>
                                    <TableCell
                                        sx={{ backgroundColor: "#90DB4196" }}>
                                        <div className="pm25-class">
                                            ดี
                                        </div>
                                        <div className="pm25-class">
                                            15.1-25.0 µg/m³
                                        </div>
                                    </TableCell>
                                    <TableCell
                                        sx={{ backgroundColor: "#FFD34796" }}>
                                        <div className="pm25-class">
                                            ปานกลาง
                                        </div>
                                        <div className="pm25-class">
                                            25.1-37.5 µg/m³
                                        </div>
                                    </TableCell>
                                    <TableCell
                                        sx={{ backgroundColor: "#FF984A96" }}>
                                        <div className="pm25-class">
                                            เริ่มมีผลต่อสุขภาพ
                                        </div>
                                        <div className="pm25-class">
                                            37.6-75.0 µg/m³
                                        </div>

                                    </TableCell>
                                    <TableCell
                                        sx={{ backgroundColor: "#C03A3096" }}>
                                        <div className="pm25-class">
                                            มีผลต่อสุขภาพ
                                        </div>
                                        <div className="pm25-class">
                                            &#62; 75.1 µg/m³
                                        </div>

                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>

                        {/* <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <Grid container spacing={{ xs: 1, md: 2 }}>
                                <Grid item xs={12}>
                                    ติดตั้งแอปพลิเคชัน "เช็คฝุ่น"
                                    แสกน QR code หรือคลิก
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer
                                        component={Paper}
                                        style={{ maxHeight: 240, width: "100%" }}
                                        sx={{
                                            marginBottom: 0,
                                            "&::-webkit-scrollbar": {
                                                width: 8,
                                                height: 8
                                            },
                                            "&::-webkit-scrollbar-track": {
                                                backgroundColor: "#e2f1ff"
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                                backgroundColor: "#0080ff",
                                                borderRadius: 3
                                            },
                                            "&::-webkit-scrollbar-thumb:hover": {
                                                background: "#1c5bd8"
                                            }
                                        }}
                                    >
                                        <Table>
                                            <TableRow>
                                                <TableCell align='center'>
                                                    <a href="https://apps.apple.com/th/app/%E0%B9%80%E0%B8%8A-%E0%B8%84%E0%B8%9D-%E0%B8%99/id1591356571" target="_blank">
                                                        <img src={aaplPic} height={120} alt="QR code สำหรับดาวน์โหลดแอพพลิเคชันเช็คฝุ่นสำหรับ Apple" ></img>
                                                    </a>
                                                </TableCell>
                                                <TableCell align='center'>
                                                    <a href="https://play.google.com/store/apps/details?id=com.gistda.pm25check" target="_blank">
                                                        <img src={andPic} height={120} alt="QR code สำหรับดาวน์โหลดแอพพลิเคชันเช็คฝุ่นสำหรับ Android" ></img>
                                                    </a>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align='center'>
                                                    <Button href="https://apps.apple.com/th/app/%E0%B9%80%E0%B8%8A-%E0%B8%84%E0%B8%9D-%E0%B8%99/id1591356571" target="_blank"
                                                        style={{ textTransform: 'none' }}
                                                        variant="contained">iOS</Button>
                                                </TableCell>
                                                <TableCell align='center'>
                                                    <Button href="https://play.google.com/store/apps/details?id=com.gistda.pm25check" target="_blank"
                                                        style={{ textTransform: 'none' }}
                                                        variant="contained">Android</Button>
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    </TableContainer>


                                </Grid>
                            </Grid>
                        </Typography> */}
                    </Box>
                    <Button onClick={handleCloseI}>ปิด</Button>
                </Box>
            </Modal>

            <Modal
                open={openA}
                onClose={handleCloseA}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style }}>

                    <h2 id="parent-modal-title">{modalNameA}</h2>
                    <Box margin={1}>
                        {/* <Typography gutterBottom component="div">
                            ข้อมูลรายอำเภอของจังหวัด{province.province_data.p_name}
                        </Typography> */}

                        <TableContainer sx={{
                            maxHeight: 510,
                            "&::-webkit-scrollbar": {
                                width: 5,
                                height: 5
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: "#e2f1ff"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#0080ff",
                                borderRadius: 2
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                background: "#1c5bd8"
                            }
                        }}>
                            <Table stickyHeader size="small" lang='th' aria-label="ข้อมูล PM2.5">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: 30 }} align="center">ลำดับ</TableCell>
                                        <TableCell sx={{ width: 120 }}>{modalNameA.toString().split('ของ')[0].split('ข้อมูลราย')[1]}</TableCell>
                                        <TableCell sx={{ width: 120 }} align="center"> <div>ชั่วโมงล่าสุด<br />(µg/m³)</div> </TableCell>
                                        <TableCell sx={{ width: 120 }} align="center"> <div>คาดการณ์<br />{isLoadingAmphoe ? '' : `ณ ${predDt[0]}`}<br />{isLoadingAmphoe ? '' : `${fetchedData.length > 0 && fetchedData[0].p1 * 0 === 0 ? `${predDt[1]} |` : ''} ${fetchedData.length > 0 && fetchedData[0].p2 * 0 === 0 ? `${predDt[2]} |` : ''} ${fetchedData.length > 0 && fetchedData[0].p3 * 0 === 0 ? `${predDt[3]}` : ''} `}</div> </TableCell>
                                        <TableCell sx={{ width: 120 }} align="center"> <div>เฉลี่ย<br />24 ชั่วโมง<br />(µg/m³)</div> </TableCell>
                                        <TableCell sx={{ width: 30 }} align="center">{modalNameA.toString().split('ของ')[0].split('ข้อมูลราย')[1] === 'เขต' ? 'รายแขวง' : 'รายตำบล'}</TableCell>
                                        <TableCell sx={{ width: 70 }} align="center"> <div>ข้อมูล<br />กราฟ</div> </TableCell>
                                        <TableCell sx={{ width: 120 }} align="center"><div>ข้อมูลล่าสุด<br />เวลา</div></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {isLoadingAmphoe
                                        ?
                                        <TableRow>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                        </TableRow>

                                        : fetchedDataAmphoe.map((amphoe, index) => (
                                            <StyledTableRow>
                                                <TableCell align="center">{index + 1}</TableCell>
                                                <TableCell>{amphoe.a_name}</TableCell>
                                                <TableCell component="th" scope="row" align="center">
                                                    <div align='center'>
                                                        <StyledTableCell value={amphoe.a_PM25} component="th" align="center">
                                                            {amphoe.a_PM25}
                                                        </StyledTableCell>
                                                    </div>
                                                </TableCell>

                                                <TableCell component="th" scope="row" align="center" style={{ width: '20%' }} margin='10'>
                                                    <Stack align='center' direction="row" spacing={0.25}>

                                                        {amphoe.p1 * 0 === 0 ?
                                                            <StyledTableCell value={amphoe.p1} component="th" align="center">
                                                                {(amphoe.p1 === amphoe.p_PM25 ? '' : (parseFloat(amphoe.p1) > parseFloat(amphoe.a_PM25) ? '' : '')) + amphoe.p1}
                                                            </StyledTableCell>
                                                            : ''}
                                                        {amphoe.p2 * 0 === 0 ?
                                                            <StyledTableCell value={amphoe.p2} component="th" align="center">
                                                                {(amphoe.p2 === amphoe.p1 ? '' : (parseFloat(amphoe.p2) > parseFloat(amphoe.p1) ? '' : '')) + amphoe.p2}
                                                            </StyledTableCell>
                                                            : ''}
                                                        {amphoe.p3 * 0 === 0 ?
                                                            <StyledTableCell value={amphoe.p3} component="th" align="center">
                                                                {(amphoe.p3 === amphoe.p2 ? '' : (parseFloat(amphoe.p3) > parseFloat(amphoe.p2) ? '' : '')) + amphoe.p3}
                                                            </StyledTableCell>
                                                            : ''}
                                                    </Stack>
                                                </TableCell>

                                                <TableCell component="th" scope="row" align="center">
                                                    <div align='center'>
                                                        <StyledTableCell value={amphoe.a_24PM25} component="th" align="center">
                                                            {amphoe.a_24PM25}
                                                        </StyledTableCell>
                                                    </div>
                                                </TableCell>

                                                <TableCell align="center">
                                                    <IconButton
                                                        lang='th'
                                                        aria-label="กดเพื่อดูรายละเอียดรายตำบล"
                                                        size="small"
                                                        onClick={() => handleOpenT(amphoe.a_id, amphoe.a_name)}>
                                                        <FormatListNumberedIcon />
                                                    </IconButton>
                                                </TableCell>

                                                <TableCell component="th" scope="row" align="center">
                                                    <div>
                                                        <Button onClick={() => handleOpen(amphoe.a_id, 'Amphoe', amphoe.a_name)}>
                                                            <ShowChartIcon></ShowChartIcon>
                                                        </Button>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right">{amphoe.a_datetime}</TableCell>
                                            </StyledTableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </Box>
                    <Button onClick={handleCloseA}>ปิด</Button>
                </Box>
            </Modal>


            <Modal
                open={openT}
                onClose={handleCloseT}
                lang='th'
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style }}>
                    <h2 id="parent-modal-title">{modalNameT}</h2>
                    <Box margin={1}>
                        {/* <Typography gutterBottom component="div">
                            ข้อมูลรายอำเภอของจังหวัด{province.province_data.p_name}
                        </Typography> */}

                        <TableContainer sx={{
                            maxHeight: 510,
                            "&::-webkit-scrollbar": {
                                width: 5,
                                height: 5
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: "#e2f1ff"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#0080ff",
                                borderRadius: 2
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                background: "#1c5bd8"
                            }
                        }}>
                            <Table stickyHeader size="small" lang='th' aria-label="ข้อมูล PM2.5">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: 30 }} align="center">ลำดับ</TableCell>
                                        <TableCell sx={{ width: 120 }}>{modalNameT.toString().split('ของ')[0].split('ข้อมูลราย')[1]}</TableCell>
                                        <TableCell sx={{ width: 120 }} align="center"> <div>ชั่วโมงล่าสุด<br />(µg/m³)</div> </TableCell>
                                        <TableCell sx={{ width: 120 }} align="center"> <div>คาดการณ์<br />{isLoadingTambon ? '' : `ณ ${predDt[0]}`}<br />{isLoadingTambon ? '' : `${fetchedData.length > 0 && fetchedData[0].p1 * 0 === 0 ? `${predDt[1]} |` : ''} ${fetchedData.length > 0 && fetchedData[0].p2 * 0 === 0 ? `${predDt[2]} |` : ''} ${fetchedData.length > 0 && fetchedData[0].p3 * 0 === 0 ? `${predDt[3]}` : ''} `}</div> </TableCell>
                                        <TableCell sx={{ width: 120 }} align="center"> <div>เฉลี่ย 24 ชั่วโมง<br />(µg/m³)</div> </TableCell>
                                        <TableCell sx={{ width: 70 }} align="center"> <div>ข้อมูล<br />กราฟ</div> </TableCell>
                                        <TableCell sx={{ width: 120 }} align="center"><div>ข้อมูลล่าสุด<br />เวลา</div></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {isLoadingTambon
                                        ?
                                        <TableRow>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton animation="wave" />
                                            </TableCell>
                                        </TableRow>

                                        : fetchedDataTambon.map((tambon, index) => (
                                            <StyledTableRow>
                                                <TableCell align="center">{index + 1}</TableCell>
                                                <TableCell>{tambon.t_name}</TableCell>
                                                <TableCell component="th" scope="row" align="center">
                                                    <div align='center'>
                                                        <StyledTableCell value={tambon.t_PM25} component="th" align="center">
                                                            {tambon.t_PM25}
                                                        </StyledTableCell>
                                                    </div>
                                                </TableCell>

                                                <TableCell component="th" scope="row" align="center" style={{ width: '20%' }} margin='10'>
                                                    <Stack align='center' direction="row" spacing={0.25}>

                                                        {tambon.p1 * 0 === 0 ?
                                                            <StyledTableCell value={tambon.p1} component="th" align="center">
                                                                {(tambon.p1 === tambon.p_PM25 ? '' : (parseFloat(tambon.p1) > parseFloat(tambon.t_PM25) ? '' : '')) + tambon.p1}
                                                            </StyledTableCell>
                                                            : ''}
                                                        {tambon.p2 * 0 === 0 ?
                                                            <StyledTableCell value={tambon.p2} component="th" align="center">
                                                                {(tambon.p2 === tambon.p1 ? '' : (parseFloat(tambon.p2) > parseFloat(tambon.p1) ? '' : '')) + tambon.p2}
                                                            </StyledTableCell>
                                                            : ''}
                                                        {tambon.p3 * 0 === 0 ?
                                                            <StyledTableCell value={tambon.p3} component="th" align="center">
                                                                {(tambon.p3 === tambon.p2 ? '' : (parseFloat(tambon.p3) > parseFloat(tambon.p2) ? '' : '')) + tambon.p3}
                                                            </StyledTableCell>
                                                            : ''}
                                                    </Stack>
                                                </TableCell>


                                                <TableCell component="th" scope="row" align="center">
                                                    <div align='center'>
                                                        <StyledTableCell value={tambon.t_24PM25} component="th" align="center">
                                                            {tambon.t_24PM25}
                                                        </StyledTableCell>
                                                    </div>
                                                </TableCell>
                                                <TableCell component="th" scope="row" align="center">
                                                    <div>
                                                        <Button onClick={() => handleOpen(tambon.t_id, 'Tambon', tambon.t_name)}>
                                                            <ShowChartIcon></ShowChartIcon>
                                                        </Button>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right">{tambon.t_datetime}</TableCell>
                                            </StyledTableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </Box>
                    <Button onClick={handleCloseT}>ปิด</Button>
                </Box>
            </Modal>

            <Modal
                open={open1}
                onClose={handleClose1}
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        ติดตั้งแอปพลิเคชัน "เช็คฝุ่น"
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <Grid container spacing={{ xs: 1, md: 2 }}>
                            <Grid item xs={12}>
                                แสกน QR code หรือคลิก
                            </Grid>
                            <Grid item xs={12}>
                                <TableContainer
                                    component={Paper}
                                    style={{ maxHeight: 780, width: "100%" }}
                                    sx={{
                                        marginBottom: 0,
                                        "&::-webkit-scrollbar": {
                                            width: 8,
                                            height: 8
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            backgroundColor: "#e2f1ff"
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            backgroundColor: "#0080ff",
                                            borderRadius: 3
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            background: "#1c5bd8"
                                        }
                                    }}
                                >
                                    <Table>
                                        <TableRow>
                                            <TableCell align='center'>
                                                <a href="https://apps.apple.com/th/app/%E0%B9%80%E0%B8%8A-%E0%B8%84%E0%B8%9D-%E0%B8%99/id1591356571" target="_blank">
                                                    <img lang='th' src={aaplPic} height={250} alt="QR code สำหรับดาวน์โหลดแอพพลิเคชันเช็คฝุ่นสำหรับ Apple" ></img>
                                                </a>
                                            </TableCell>
                                            <TableCell align='center'>
                                                <a href="https://play.google.com/store/apps/details?id=com.gistda.pm25check" target="_blank">
                                                    <img lang='th' src={andPic} height={250} alt="QR code สำหรับดาวน์โหลดแอพพลิเคชันเช็คฝุ่นสำหรับ Android" ></img>
                                                </a>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='center'>
                                                <Button href="https://apps.apple.com/th/app/%E0%B9%80%E0%B8%8A-%E0%B8%84%E0%B8%9D-%E0%B8%99/id1591356571" target="_blank"
                                                    style={{ textTransform: 'none' }}
                                                    variant="contained">iOS</Button>
                                            </TableCell>
                                            <TableCell align='center'>
                                                <Button href="https://play.google.com/store/apps/details?id=com.gistda.pm25check" target="_blank"
                                                    style={{ textTransform: 'none' }}
                                                    variant="contained">Android</Button>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </TableContainer>


                            </Grid>
                        </Grid>
                    </Typography>
                </Box>
            </Modal>

            <Modal
                open={open}
                onClose={handleClose}
                lang='th'
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        ข้อมูลย้อนหลัง
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        {modalName}
                        {isLoading24 ?
                            <Box sx={{ display: 'flex' }}>
                                <CircularProgress />
                            </Box>
                            :
                            <Box>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={options1}
                                />
                            </Box>

                        }
                    </Typography>
                    <Button onClick={handleClose}>ปิด</Button>
                </Box>
            </Modal>
            {/* </ThemeProvider> */}
        </div >
    );
}

export default Home;


// https://webcheck.aaa.in.th/?testId=ArsbrhsXcI3dBBu01WLzkRQCINChtRmJvfN417jFQjp00a0vZq